(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-hub-sticky-cta"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-sticky-cta')) {
		class LTAStickyCta extends HTMLElement {
			constructor() {
				super()
				this._onScroll = this._onScroll.bind(this)
				this._ticking = false
			}

			connectedCallback() {
				if (window.Shopify?.designMode) {
					this.toggleAttribute('data-visible', true)
					this.removeAttribute('inert')
					return
				}

				this._updateVisibility()
				window.addEventListener('scroll', this._onScroll, { passive: true })
				window.addEventListener('resize', this._onScroll, { passive: true })
			}

			disconnectedCallback() {
				window.removeEventListener('scroll', this._onScroll)
				window.removeEventListener('resize', this._onScroll)
			}

			_onScroll() {
				if (this._ticking) return
				this._ticking = true
				requestAnimationFrame(() => {
					this._updateVisibility()
					this._ticking = false
				})
			}

			_updateVisibility() {
				const visible =
					window.scrollY >= document.documentElement.scrollHeight * ((Number(this.dataset.threshold) || 30) / 100)

				this.toggleAttribute('data-visible', visible)
				this.toggleAttribute('inert', !visible)
			}
		}

		customElements.define('l-sticky-cta', LTAStickyCta)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-quick-nav"] && !Shopify.designMode) return;
  try {
    
	class QuickNavCollection extends HTMLElement {
		connectedCallback() {
			this.handleClick = this.handleClick.bind(this)
			this.addEventListener('click', this.handleClick)
		}

		disconnectedCallback() {
			this.removeEventListener('click', this.handleClick)
		}

		getCollectionSection() {
			return document.querySelector('.js-collection')
		}

		getCollectionSectionId(collectionSection) {
			const sectionWrapper = collectionSection?.closest('[id^="shopify-section-"]')
			if (!sectionWrapper?.id) return null
			return sectionWrapper.id.replace('shopify-section-', '')
		}

		getResetUrl() {
			return this.dataset.colllectionUrl || this.dataset.collectionUrl || window.location.pathname
		}

		setActiveLink(activeLink) {
			this.querySelectorAll('.l-sCQNav__link').forEach((link) => {
				link.classList.toggle('is-active', link === activeLink)
			})
		}

		async handleClick(event) {
			const link = event.target.closest('.l-sCQNav__link')
			const resetButton = event.target.closest('[data-quick-nav-reset]')
			if (!link && !resetButton) return

			const collectionSection = this.getCollectionSection()
			const sectionId = this.getCollectionSectionId(collectionSection)
			if (!collectionSection || !sectionId) return

			event.preventDefault()
			const isResetFromButton = !!resetButton
			const isResetFromActiveLink = !!link && link.classList.contains('is-active')
			const targetUrl = isResetFromButton || isResetFromActiveLink ? this.getResetUrl() : link.href
			const requestUrl = new URL(targetUrl, window.location.origin)
			requestUrl.searchParams.set('section_id', sectionId)

			try {
				const response = await fetch(requestUrl.toString(), {
					headers: { 'X-Requested-With': 'XMLHttpRequest' },
				})
				if (!response.ok) throw new Error(`Failed to fetch section: ${response.status}`)

				const html = await response.text()
				const parsed = new DOMParser().parseFromString(html, 'text/html')
				const incomingCollection = parsed.querySelector('.js-collection')

				if (incomingCollection) {
					collectionSection.replaceWith(incomingCollection)
				} else {
					collectionSection.innerHTML = parsed.body.innerHTML
				}

				if (!isResetFromButton && !isResetFromActiveLink && link) {
					this.setActiveLink(link)
				} else {
					this.setActiveLink(null)
				}

				history.pushState({}, '', targetUrl)
			} catch (error) {
				window.location.href = targetUrl
			}
		}
	}

	if (!customElements.get('quick-nav-collection')) {
		customElements.define('quick-nav-collection', QuickNavCollection)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super()
			this.elements = {
				input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
			}
			this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)))
		}

		onItemClick(event) {
			event.preventDefault()
			const form = this.querySelector('form')
			this.elements.input.value = event.currentTarget.dataset.value
			if (form) form.submit()
		}
	}

	customElements.define('localization-form', LocalizationForm)

  } catch(e) { console.error(e); }
})();
})();
